"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _formatDuration = require("./formatDuration");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var printParts = function printParts(tokens) {
  return tokens.map(function (token) {
    return token.value;
  }).join("").trim();
};
var FormattedDuration = function FormattedDuration(props) {
  var intl = (0, _reactIntl.useIntl)();
  var children = props.children;
  var seconds = props.seconds,
    _props$textComponent = props.textComponent,
    Text = _props$textComponent === void 0 ? intl.textComponent : _props$textComponent,
    _props$valueComponent = props.valueComponent,
    Value = _props$valueComponent === void 0 ? Text : _props$valueComponent;
  var tokens = (0, _formatDuration.formatDurationToParts)(intl, seconds, props);
  if (typeof children === "function") {
    return children({
      value: printParts(tokens),
      tokens: tokens
    });
  }
  return /*#__PURE__*/_react["default"].createElement(Text, null, tokens.map(function (_ref, i) {
    var type = _ref.type,
      value = _ref.value;
    if (value.trim().length === 0) {
      return value;
    }
    switch (type) {
      case "unit":
      case "literal":
        return /*#__PURE__*/_react["default"].createElement(Text, {
          key: i
        }, value);
      default:
        return /*#__PURE__*/_react["default"].createElement(Value, {
          key: i
        }, value);
    }
  }));
};
var _default = exports["default"] = FormattedDuration;